module.exports = __webpack_public_path__ + "img/img7.0f71e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img7.png
// module id = 182
// module chunks = 0